import { decode } from "../../config";
import { apiFetch } from "../../utils/api";

const API_BASE_URL = decode(window._env_?.API_BASE_URL);

// ✅ Get All PromoCodes
export const getPromoCodes = () => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/PromoCodes/GetAll`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    const data = await response.json();
    dispatch({ type: "SET_PROMOCODES", payload: data });
    return data;
  } catch (err) {
    console.error("Error loading promo codes:", err);
  }
};

export const addPromoCode = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/PromoCodes/AddPromo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "ADD_PROMOCODE", payload: data });
    return obj;
  } catch (err) {
    console.error("Error adding promocode :", err);
  }
};

export const updatePromoCode = (obj) => async (dispatch) => {
  try {
    const response = await apiFetch(`${API_BASE_URL}/PromoCodes/UpdatePromo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "UPDATE_PROMOCODE", payload: data });
    return obj;
  } catch (err) {
    console.error("Error updating promocode :", err);
  }
};

export const togglePromoCode = (id) => async (dispatch) => {
  let obj = {
    Id: id,
  };
  try {
    const response = await apiFetch(`${API_BASE_URL}/PromoCodes/ToggleActive`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    });
    const data = await response.json();
    dispatch({ type: "TOGGLE_PROMOCODE", payload: data });
    return obj;
  } catch (err) {
    console.error("Error updating promocode :", err);
  }
};

export const promocodeUsageData = (id) => async (dispatch) => {
  let obj = {
    Id: id,
  };
  try {
    const response = await apiFetch(
      `${API_BASE_URL}/PromoCodes/PromoCodeUsageData`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
      },
    );
    const data = await response.json();
    dispatch({ type: "USED_PROMOCODE", payload: data });
    return obj;
  } catch (err) {
    console.error("Error fetching promocode usage data :", err);
  }
};

export const validatePromoCode = (requestData) => async () => {
  try {
    const response = await apiFetch(
      `${API_BASE_URL}/PromoCodes/ValidatePromoCode`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error updating promocode :", err);
  }
};

export const allPromotionBanner = () => async (dispatch) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/PromoCodes/GetAllPromoBanners`,
      {
        method: "GET",
      },
    );

    if (!response.ok) {
      console.error(
        "Failed to fetch promo banners:",
        response.status,
        response.statusText,
      );
      localStorage.setItem("promobanner", JSON.stringify(false));
      dispatch({ type: "GET_PROMO_BANNERS", payload: [] });
      return;
    }
    const data = await response.json();
    localStorage.setItem(
      "promobanner",
      data.length > 0 ? JSON.stringify(true) : JSON.stringify(false),
    );
    dispatch({ type: "GET_PROMO_BANNERS", payload: data });

    return data;
  } catch (err) {
    console.error("Error loading promo banners:", err);
  }
};
